export default __webpack_public_path__ + "static/media/bg-2.660e8e04.svg";